import { TransferdFacilityType } from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepperData = ["対象施設一覧/対象外施設への異動情報", "機構へ提出"];

const headList1 = [
  {
    headTitle: "職員番号",
    helpText: "異動する職員の職員番号です。",
  },
  {
    headTitle: "職員氏名",
    helpText: "異動する職員の職員氏名（フリガナ）です。",
  },
  {
    headTitle: "職員名漢字",
    helpText:
      "異動する職員の職員氏名（漢字）です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されない場合があります。",
  },
  {
    headTitle: "生年月日",
    helpText: "異動する職員の生年月日です。",
  },
];

const headList2 = [
  {
    headTitle: "施設名称",
    helpText: "異動元の施設番号と施設名称です。",
  },
  {
    headTitle: "施設種類",
    helpText: "異動元施設等の名称です。",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "異動後の施設",
  },
  {
    title: "施設名",
    keyword: "facilityName",
    requiredIcon: true,
    inputProps: { maxLength: 20 },
    helpicon: true,
    helpText: "異動する契約対象外施設等の名称を入力してください。",
  },
  {
    title: "種類",
    keyword: "facilityKind",
    type: "selectForm",
    selectPropsList: TkGetCodeList(TransferdFacilityType),
    requiredIcon: true,
    helpicon: true,
    helpText:
      "異動する契約対象外施設等の施設種類・サービス種類を選択してください。",
  },

  {
    title: "経営施設であることを確認できる書類の添付",
    keyword: "upload",
    type: "downloadLink",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "異動先の施設・事業が同一の共済契約者の経営であることが確認できる書類（「定款」（写）、認可書（写）、指定通知書（写）等）",
  },
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "異動年月日",
  },
  {
    title: "共済契約対象施設等最終在籍年月日",
    keyword: "lastDay",
    type: "text",
    helpicon: true,
    helpText:
      "制度に加入していない施設・事業（契約対象外施設）へ配属された日の前日です。（契約対象外施設へ4/1に配属であれば、その前日の3/31となります。）",
  },
];

const schema = {
  facilityName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  facilityKind: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  upload: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { stepperData, headList1, headList2, fakeTableList, schema };
